(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('external-resource', {
            /*
            parent: 'entity',
            */
            parent: 'admin',
            url: '/external-resource?page&sort&search',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'telestatApp.externalResource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/external-resource/external-resources.html',
                    controller: 'ExternalResourceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('externalResource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('external-resource-detail', {
            parent: 'external-resource',
            url: '/external-resource/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'telestatApp.externalResource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/external-resource/external-resource-detail.html',
                    controller: 'ExternalResourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('externalResource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExternalResource', function($stateParams, ExternalResource) {
                    return ExternalResource.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'external-resource',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('external-resource-detail.edit', {
            parent: 'external-resource-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-dialog.html',
                    controller: 'ExternalResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('external-resource.new', {
            parent: 'external-resource',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-dialog.html',
                    controller: 'ExternalResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                externalUrl: null,
                                loadingType: null,
                                period: null,
                                loadTime: null,
                                lastDownload: null,
                                lastSuccessProcessing: null,
                                lastModified: null,
                                uploadFolder: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                healthIndicator: null,
                                description: null,
                                charset: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('external-resource');
                });
            }]
        })
        .state('external-resource.edit', {
            parent: 'external-resource',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-dialog.html',
                    controller: 'ExternalResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('external-resource.delete', {
            parent: 'external-resource',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-delete-dialog.html',
                    controller: 'ExternalResourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
